var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,12.5c0,2.48-2.02,4.5-4.5,4.5h-4.5v-2h4.5c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5h-6.5v2h-1l-3-3,3-3h1v2h6.5c2.48,0,4.5,2.02,4.5,4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/1787897133/media/icon-undo.f22966080fd02cfb624ed252ca9d3311.svg";
export { ForwardRef as ReactComponent };